import Model from "@tripian/model";
import React, { useEffect, useRef } from "react";
import QRCode from "react-qr-code";

interface IGuestShareHeaderProps {
  tripUrl: string;
  onMountShare?: () => void;
  t: (value: Model.TranslationKey) => string;
}

const GuestShareHeader: React.FC<IGuestShareHeaderProps> = ({
  tripUrl,
  onMountShare,
  t,
}) => {
  const calledRef = useRef(false);
  const isValaiLanding = window.tconfig.LANDING_PAGE === "ValaiLanding";

  useEffect(() => {
    if (!window.tconfig.GUEST_LOGIN) return;
    if (calledRef.current) return;
    calledRef.current = true;
    if (onMountShare) onMountShare();
  }, [onMountShare]);

  if (!isValaiLanding)
  {
      if (!window.tconfig.GUEST_LOGIN) return null;
  }

  return (
    <div className="hidden sm:flex items-center justify-center gap-3">
      <div className="text-xs md:text-sm font-medium text-center whitespace-normal md:max-w-[180px] lg:whitespace-nowrap lg:max-w-none">
        <span>{t("scanQrCode")}</span>
        <br className="hidden md:inline lg:hidden" />
        <span> {t("openOnYourDevice")}</span>
      </div>
      <div className="bg-white p-1 rounded-md border">
        <QRCode value={tripUrl} size={60} />
      </div>
    </div>
  );
};

export default GuestShareHeader;
